<template lang="pug">
  //- Barra de filtros de búsqueda
  .b2b-filters
    b2b-search-bar
      div.block(slot='header')
        span.dateHeader {{ $t('users.filters.registration_date.value') }}
        ods-date-picker.ods-md-3(
          v-model='dateTimePickerValue',
          type='datetimerange',
          :picker-options='pickerOptions2',
          @change='getDateTimePickerValue',
          :range-separator='$t("msg_generics.datepicker.separator")',
          :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
          :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
          :format='$t("date_format_long_datepicker")',
          :canSelectSeconds='true',
          :default-time="['00:00:00', '23:59:59']",
          prefix-icon='prefix-icon-date-time-picker',
          :showFooterButtons='true',
          align='right')
        ods-tooltip(:content='$t("buttons.refresh_tooltip")', placement='bottom')
          ods-button(
            icon='ods-icon-refresh',
            size='medium',
            style=' padding-left: 0px; padding-right: 10px; margin-right: 8px',
            circle,
            @click="activeRefreshResults")
        ods-tooltip(:content='$t("parties.buttons.mass_partyupdate_tooltip")', placement='bottom')
          ods-button(
            v-if='canAdminIndra && withProject',
            size='medium',
            icon='ods-icon-refresh'
            @click.native='handleGoMassiveUpdate')
            | {{ $t('parties.buttons.mass_partyupdate') }}
        ods-tooltip(:content='$t("parties.buttons.add_party_tooltip")', placement='bottom')
          ods-button(
            v-if='canCreateParty && withProject',
            size='medium',
            icon='ods-icon-upload'
            @click.native='handleGoNewParty')
            | {{ $t('parties.buttons.add_party') }}
        ods-tooltip(:content='$t("parties.buttons.mass_partycharge_tooltip")', placement='bottom')
          ods-button.rightbut(
            v-if='canAdminPartyAdvanced && withProject',
            size='medium',
            icon='ods-icon-upload'
            @click.native='handleGoMassiveCharge')
            | {{ $t('parties.buttons.mass_partycharge') }}
        ods-tooltip(
          v-if='canAdminApprovalFlowByLevels && approvalFlowConfigurationInProject && withProject',
          :content='$t("centres.buttons.massive_upload_tooltip")', placement='bottom')
          ods-button.rightbut(
            size='medium',
            icon='ods-icon-upload'
            @click.native='handleGoMassiveChargeApprovalFlow')
            | {{ $t('centres.buttons.massive_upload_button') }}

      div(slot='body')
        ods-form.b2b-filters__area(
          :model='filterForm',
          :rules='rules',
          ref='filterForm',
          @submit.native.prevent='')
          ods-form-item.first-input(prop='firstValue')
            //- b2b-select
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='filterForm.firstValue',
              :placeholder='$t("msg_generics.advanced_search")',
              @change='getFirstValue')
              ods-option(
                v-for='option in options',
                :key='option.col',
                :label='$t(option.value)',
                :disabled='option.selected',
                :value='option')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              //- Select type
              div(v-if="selected.componente === 'select'")
                ods-form-item.others-input(prop='secondValueSelect')
                  ods-select(v-if="selected.prop === 'idProject'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='option.name',
                      :value='option')
                  ods-select(v-else-if="selected.prop === 'buyer' || selected.prop === 'seller' || selected.prop === 'third' || selected.prop === 'propietary' || selected.prop === 'active'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='$t("msg_generics.question." + option.type)',
                      :value='option.id')
                  ods-select(v-else-if="selected.prop === 'country'",
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.value',
                      :label='option.name',
                      :value='option.value')
                  ods-select(v-else
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='option.code',
                      :value='option')

              //- Input type
              div(v-else-if="selected.componente === 'input' && selected.tipo === 'string'")
                ods-form-item.others-input(prop='secondValue')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model='filterForm.secondValue',
                    @input='getSecondValue')

              div(v-else)
                ods-form-item.others-input(prop='secondValueNumber')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model.number='filterForm.secondValueNumber',
                    @input='getSecondValue')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              ods-tooltip(:content='$t("buttons.btnAdd")', placement='bottom')
                ods-button(
                  icon='ods-icon-plus',
                  size='medium',
                  circle,
                  @click.native="onSubmit('filterForm')")

      //- Dialog carga masiva (tanto de empresas como de flujos de aprobación)
      //- Se reutiliza el mismo dialog para ambos tipos de carga masiva
      ods-dialog(
        :title="massiveUploadType === 'approvalFlow' ? $t('centres.approval_flow_massive_charge.title') : $t('parties.buttons.mass_partycharge_tooltip')"
        :visible.sync="massChargeDialogFormVisible"
        ref='massChargeDialog',
        :append-to-body="true")
        div(style='margin-bottom: 2rem; font-size: larger')
          | {{ massiveUploadType === 'approvalFlow' ? $t('centres.approval_flow_massive_charge.message') : $t('parties.mass_party_chargemsg') }}
        ods-form(
          :rules='rulesDialogmassCharge',
          :model='massChargeDialogForm'
          ref='massChargeDialogForm')
          ods-form-item(prop='file', ref='form-item-upload')
            ods-upload(
              v-model='massChargeDialogForm.file',
              ref='upload',
              action='#',
              :auto-upload='false',
              :on-change='onSuccessUpload',
              :on-remove='handleRemoveUpload',
              accept= '.csv'
              :file-list='fileList')
                ods-button(
                  icon='ods-icon-plus',
                  size='small',
                  circle)
                  | {{ $t('users.user_upload') }}
          ods-form-item(style='text-align: right')
            ods-button(
              type='primary'
              @click.native="handleMassiveCharge('massChargeDialogForm')")
              | {{ $t('parties.buttons.mass_upload') }}

    .b2b-filters__container(v-if='listSelectedFiltersPartiesService.length > 0')
      transition-group.b2b-filters__group(
        name='ods-fade-in-linear',
        tag='div')
        ods-popover(
          key='icon-delete-filters',
          placement='top-start',
          trigger='hover',
          :content='$t("msg_generics.popover_clean_filters")')
          ods-button.clean-filters(
            slot='reference',
            type='neutral',
            size='small',
            icon='ods-icon-delete'
            @click='handleDeleteAllFilters')

        .b2b-filters__button(
          v-for='(filter, index) in listSelectedFiltersPartiesService',
          :key='index')
          b2b-filter-button-parties-service(
            :filter='filter',
            @closeTag='resetSelectedOneOption')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bSearchBar from '@/components/B2bSearchBar'
import B2bFilterButtonPartiesService from './B2bFilterButtonPartiesService'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filters-parties-service',

  props: {
    filterOptions: {
      type: Object,
      required: true
    }
  },

  mixins: [Utils],

  components: {
    B2bSearchBar,
    B2bFilterButtonPartiesService
  },

  data () {
    const _this = this
    return {
      // Forumlario
      filterForm: {
        firstValue: '',
        secondValue: '',
        secondValueNumber: '',
        secondValueSelect: ''
      },
      dateTimePickerValue: [],
      pickerOptions2: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('msg_generics.datepicker.today'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'today')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_week'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastWeek')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_month'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastMonth')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_three_months'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastThreeMonths')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastYear')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_two_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastTwoYear')
            }
          }
        ]
      },
      withProject: true,
      selected: {},
      selectedFilters: [],
      options: {},
      auxListParties: [],
      massChargeDialogFormVisible: false,
      massiveUploadType: null, // Tipo de carga masiva (parties o approvalFlow)
      approvalFlowConfigurationInProject: false, // true si el proyecto tiene la configuración de flujo de aprobación, false en caso contrario
      massChargeDialogForm: {
        service: null,
        file: null
      },
      tid: null,
      extensionFormats: ['.csv'],
      fileList: [],

      // Reglas Validación
      rules: {
        secondValue: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 3, message: this.$t('msg_generics.min_three_letters') }
        ],
        secondValueNumber: [
          { required: true, message: this.$t('msg_generics.field_required') },
          { type: 'number', message: this.$t('msg_generics.number_required') }
        ],
        secondValueSelect: [
          { required: true, message: this.$t('msg_generics.element_selected'), trigger: 'change' }
        ]
      },
      rulesDialogmassCharge: {
        file: [
          {
            required: true,
            message: this.$t(
              'pendingtask.pendingtask_detail.attachments_table.fileselected'
            ),
            trigger: 'click'
          }
        ]
      }
    }
  },

  computed: {
    ...mapGetters([
      'queryPartiesService',
      'listSelectedFiltersPartiesService',
      'optionsFilterPartyNamePartiesServices',
      'optionsFilterPartyTaxIdNumberPartiesServices',
      'optionsFilterPartyRegisterDatePartiesServices',
      'optionsFilterPartyBuyerPartiesServices',
      'optionsFilterPartyPropietaryPartiesServices',
      'optionsFilterPartySellerPartiesServices',
      'optionsFilterPartyActivePartiesServices',
      'optionsFilterPartyCountryPartiesServices',
      'canCreateParty',
      'canAdminIndra',
      'canAdminPartyAdvanced',
      'canAdminApprovalFlowByLevels',
      'countries'
    ])
  },

  watch: {
    '$route' (to) {
      this.listSelectedFiltersPartiesServiceState = this.listSelectedFiltersPartiesServiceState // eslint-disable-line
    }
  },

  methods: {
    activeRefreshResults () {
      this.refreshResults()
    },
    ...mapActions([
      'getPartiesService',
      'queryPartiesServiceState',
      'listSelectedFiltersPartiesServiceState',
      'optionsFilterPartyNamePartiesServicesState',
      'optionsFilterPartyRegisterDatePartiesServicesState',
      'optionsFilterPartyBuyerPartiesServicesState',
      'optionsFilterPartyPropietaryPartiesServicesState',
      'optionsFilterPartySellerPartiesServicesState',
      'optionsFilterPartyActivePartiesServicesState',
      'optionsFilterPartyCountryPartiesServicesState',
      'massivePartiesUpload',
      'massiveApprovalFlowUpload',
      'getDataConfigurationCode',
      'updateMassiveParties'
    ]),

    getFirstValue (data) {
      this.filterForm.secondValue = ''
      this.$refs.filterForm.clearValidate()
      this.selected = data
      const aux = []
      this.optionsFilterPartyNamePartiesServicesState(aux)
    },

    getSecondValue (data) {
      if (this.selected.componente === 'select' && this.selected.prop === 'idProject') {
        this.selected.query = data.id
        this.selected.labelText = data.name
        this.filterForm.secondValueSelect = data.name
      } else if (this.selected.prop === 'buyer' || this.selected.prop === 'seller' || this.selected.prop === 'third' ||
        this.selected.prop === 'propietary' || this.selected.prop === 'active') {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.value
        this.selected.labelText = this.$t('msg_generics.question.' + option.type)
      } else if (this.selected.prop === 'country') {
        const option = this.selected.options.find(function (elem) {
          return elem.value === data
        })
        this.selected.query = option.value
        this.selected.labelText = option.name
      } else {
        this.selected.query = data.id
        this.selected.labelText = data.code
        this.filterForm.secondValueSelect = data.code
      }

      if (this.selected.componente === 'input') {
        this.selected.query = data
        this.selected.labelText = data
      }

      this.$refs.filterForm.clearValidate()
    },

    getThirdValue (data) {
      console.log('data:', data)
    },
    async handleMassiveCharge (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          console.log('handleMassiveCharge', this.fileList)
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.upload_parties_massive')
          })
          try {
            if (!this.validateExtension(this.massChargeDialogForm.file.name)) {
              this.massChargeDialogForm.file = null
              this.fileList = []
              this.$notify({
                title: this.$t('msg_generics.format_invalid_req_csv'),
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-error',
                duration: 10000
              })
            } else if (this.massiveUploadType === 'parties') {
              const responseCargaMassive = await this.massivePartiesUpload(this.massChargeDialogForm)
              // Reiniciamos formulario, cerramos dialog y mostramos notificacion
              this.$notify({
                title: this.$t('msg_generics.upload_attachment_ok') + ' ' + this.$t('parties.notify.loadmassive_numlinesOK') + ' ' + responseCargaMassive.data.numlinesOK,
                type: 'success',
                position: 'top-right',
                customClass: 'b2b-notification-success',
                duration: 10000
              })
            } else if (this.massiveUploadType === 'approvalFlow') {
              const responseCargaMassive = await this.massiveApprovalFlowUpload(this.massChargeDialogForm)
              // Reiniciamos formulario, cerramos dialog y mostramos notificacion
              this.$notify({
                title: this.$t('msg_generics.upload_attachment_ok') + ' ' + this.$t('parties.notify.loadmassive_numlinesOK') + ' ' + responseCargaMassive.data.numlinesOK,
                type: 'success',
                position: 'top-right',
                customClass: 'b2b-notification-success',
                duration: 10000
              })
            }
          } catch (error) {
            console.log('handleMassiveCharge CATCH: ', error)
            if (error.status === 504 || error.status === 502) {
              this.$notify({
                title: this.$t('parties.notify.loadmassive_timeout'),
                type: 'info',
                position: 'top-right',
                customClass: 'b2b-notification-info',
                duration: 6000
              })
            } else {
              this.getNotificationErrorMessage(error, 30000)
            }
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.massChargeDialogFormVisible = false
          }
        } else {
          return false
        }
      })
    },
    validateExtension (filename) {
      return this.extensionFormats.includes('.'.concat((filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)).toLowerCase()))
    },
    onSubmit (formName) {
      console.log(formName)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.filter_selected')
          })
          const dataQuery = {
            query: {},
            serviceId: this.$route.params.projectId
          }

          try {
            console.log('1 Filtro Seleccionado: ', this.selected)
            const column = this.selected.prop

            switch (column) {
              case 'partyName':
                this.queryPartiesService.partyName = this.selected.query
                break
              case 'partyTaxIdNumber':
                this.queryPartiesService.partyTaxIdNumber = this.selected.query.trim()
                break
              case 'gln':
                this.queryPartiesService.gln = this.selected.query.trim()
                break
              case 'buyer':
                this.queryPartiesService.buyer = this.selected.query
                break
              case 'seller':
                this.queryPartiesService.seller = this.selected.query
                break
              case 'third':
                this.queryPartiesService.third = this.selected.query
                break
              case 'propietary':
                this.queryPartiesService.sponsor = this.selected.query
                break
              case 'active':
                this.queryPartiesService.active = this.selected.query
                break
              case 'country':
                this.queryPartiesService.country = this.selected.query
                break
              case 'registerDate':
                this.queryPartiesService.partyRegisterDate = this.selected.query
                break
              default:
                break
            }

            this.selectedFilters = this.listSelectedFiltersPartiesService
            this.selected.selected = true
            this.selectedFilters.push(this.selected)
            await this.listSelectedFiltersPartiesServiceState(this.selectedFilters)

            this.selected = {}
            this.$refs[formName].resetFields()

            this.queryPartiesService.projectId = this.$route.params.projectId
            this.queryPartiesService.page = 0
            await this.queryPartiesServiceState(this.queryPartiesService)
            dataQuery.query = this.queryPartiesService
            const response = await this.getPartiesService(dataQuery)
            this.totalResults = response.data.totalElements
          } catch (error) {
            console.log('onSubmit FILTER CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            this.initForm()
            load.close()
          }
        } else {
          console.log('error submit!!')
        }
      })
    },
    async getDateTimePickerValue () {
      console.log('getDateTimePickerValue: ', this.dateTimePickerValue)
      if (!this.dateTimePickerValue) {
        this.queryPartiesService.creationDateTimeFrom = ''
        this.queryPartiesService.creationDateTimeTo = ''
      } else {
        this.queryPartiesService.creationDateTimeFrom = this.dateTimePickerValue[0]
        this.queryPartiesService.creationDateTimeTo = this.dateTimePickerValue[1]
      }

      const dataQuery = {
        query: {},
        serviceId: this.$route.params.projectId
      }

      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_date')
      })
      try {
        this.queryPartiesService.projectId = this.$route.params.projectId
        await this.queryPartiesServiceState(this.queryPartiesService)
        dataQuery.query = this.queryPartiesService
        const response = await this.getPartiesService(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('onSubmit FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.massChargeDialogForm.file = file
      this.$refs.massChargeDialogForm.validateField('file')
    },
    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('file')
      this.fileList = []
    },
    async handleGoMassiveUpdate () {
      const dataQuery = {
        query: {},
        serviceId: this.$route.params.projectId
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.update_party')
      })
      try {
        this.queryPartiesService.projectId = this.$route.params.projectId
        dataQuery.query = this.queryPartiesService
        await this.updateMassiveParties(dataQuery)
        this.$notify({
          title: this.$t('msg_generics.update_party_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        // Actualizamos la lista de empresas para ver los nombres actualizados.
        const response = this.getPartiesService(dataQuery)
        if (response.data && response.data.totalElements) {
          this.totalResults = response.data.totalElements
        }
      } catch (error) {
        console.log('handleGoMassiveUpdate CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        this.initForm()
        load.close()
      }
    },
    // Carga masiva de empresas
    async handleGoMassiveCharge () {
      this.massChargeDialogForm.file = null
      this.fileList = []
      this.massChargeDialogForm.service = this.$route.params.projectId
      this.massiveUploadType = 'parties' // Indicamos que es una carga masiva de empresas
      this.massChargeDialogFormVisible = true
    },
    // Carga masiva de flujos de aprobación, niveles y usuarios de centros
    async handleGoMassiveChargeApprovalFlow () {
      this.massChargeDialogForm.file = null
      this.fileList = []
      this.massChargeDialogForm.service = this.$route.params.projectId
      this.massiveUploadType = 'approvalFlow' // Indicamos que es una carga masiva de flujos de aprobación
      this.massChargeDialogFormVisible = true
    },
    async handleDeleteAllFilters () {
      console.log(this.selectedFilters)
      this.selectedFilters = []

      const dataQuery = {
        query: {},
        serviceId: this.$route.params.projectId
      }

      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete_all')
      })
      try {
        this.selectedFilters = this.listSelectedFiltersPartiesService.map(item => {
          item.labelText = ''
          item.query = ''
          item.selected = false
          return item
        })

        console.log('CLEAR FILTERS: ', this.selectedFilters)
        await this.listSelectedFiltersPartiesServiceState(this.selectedFilters)

        this.queryPartiesService.partyName = ''
        this.queryPartiesService.partyTaxIdNumber = ''
        this.queryPartiesService.gln = ''
        this.queryPartiesService.buyer = ''
        this.queryPartiesService.seller = ''
        this.queryPartiesService.third = ''
        this.queryPartiesService.sponsor = ''
        this.queryPartiesService.active = ''
        this.queryPartiesService.country = ''
        this.queryPartiesService.partyRegisterDate = ''
        this.queryPartiesService.partyTaxIdNumber = ''
        this.queryPartiesService.projectId = this.$route.params.projectId

        await this.queryPartiesServiceState(this.queryPartiesService)
        dataQuery.query = this.queryPartiesService
        const response = await this.getPartiesService(dataQuery)
        this.totalResults = response.data.totalElements
        this.selectedFilters = []
        await this.listSelectedFiltersPartiesServiceState(this.selectedFilters)

        // Reseteamos la prop selected de los filtros
        this.resetSelectedOptions(this.options)
      } catch (error) {
        console.log('getUsers CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        this.initForm()
        load.close()
      }
    },
    async refreshResults () {
      const dataQuery = {
        query: {},
        serviceId: this.$route.params.projectId
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        this.queryPartiesService.projectId = this.$route.params.projectId
        dataQuery.query = this.queryPartiesService
        const response = this.getPartiesService(dataQuery)
        if (response.data && response.data.totalElements) {
          this.totalResults = response.data.totalElements
        }
      } catch (error) {
        console.log('onSubmit FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Metodo lanzado al capturar el evento de closeTag
    async resetSelectedOneOption (data) {
      this.resetOneOption(this.options, data.filter)
      await this.listSelectedFiltersPartiesServiceState(data.listAfterRemove)
      this.initForm()
    },

    initForm () {
      if (!this.options.idfiscal.selected) {
        this.filterForm.firstValue = this.options.idfiscal
        this.selected = this.filterForm.firstValue
      } else {
        this.filterForm.firstValue = ''
        this.selected = this.filterForm.firstValue
      }
      console.log('INITfORM: ' + JSON.stringify(this.selected))
    },

    // Consulta de configuraciones del proyecto
    async getProjectConfigurations () {
      if (this.withProject) {
        const configuraciones = await this.getDataConfigurationCode({
          serviceId: this.$route.params.projectId,
          dataconfigurationCode: 'APPROVAL_FLOW_BY_LEVELS_AND_USERS'
        })
        if (configuraciones && configuraciones.length > 0) {
          if (configuraciones[0]) {
            console.log('configuraciones[0]: ', configuraciones[0])
            this.approvalFlowConfigurationInProject = true
          }
        }
      }
    },

    async getNotificationErrorMessage (error, delay) {
      let errorSms = ''
      let statusCode = null
      let durationVar = 60000
      if (delay) {
        durationVar = delay
      }

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$i18n.messages.es.error.e500
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      let errorArgList = []
      errorArgList = error.data.errorArgList
      if (errorArgList !== null && errorArgList[0].codesList !== null) {
        for (let i = 0; i < errorArgList.length; i++) {
          let fullMessage = ''
          for (let j = 0; j < errorArgList[i].codesList.length; j++) {
            if (errorArgList[i].codesList != null) {
              fullMessage = fullMessage + errorArgList[i].codesList[j] + '. '
            }
          } if (errorArgList[i].arguments === 'Ok.') {
            await this.$notify({
              title: fullMessage,
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 60000
            })
          } else {
            await this.$notify({
              title: errorArgList[i].arguments + fullMessage,
              type: 'error',
              position: 'top-right',
              customClass: 'b2b-notification-error',
              duration: durationVar
            })
          }
        }
      } else {
        this.showNotificationError(error)
      }
    },

    /* Redirige a una nueva empresa */
    handleGoNewParty () {
      router.push({
        name: 'new-party-page',
        params: {
          projectId: this.$route.params.projectId
        }
      })
    }
  },

  async created () {
    this.withProject = (this.$route.params.projectId !== undefined && this.$route.params.projectId !== null)
    console.log('this.withProject2 ', this.withProject)
    this.options.country = []
    // Creamos una copia del json que contiene los datos de los filtros y trabajamos con la copia
    this.options = JSON.parse(JSON.stringify(this.filterOptions))

    if (!this.withProject) {
      delete this.options.buyer
      delete this.options.propietary
      delete this.options.seller
      delete this.options.third
    }

    // Ponemos el estado de selected a true si ya estaba seleccionado el filtro
    this.checkListFilterSelected(this.options, this.listSelectedFiltersPartiesService)

    const paises = this.countries
    if (paises) {
      for (const p of paises) {
        this.options.country.options.push({
          value: p.id,
          name: p.name
        })
      }
    }

    this.initForm()
    try {
      await this.queryPartiesServiceState(this.queryPartiesService)
      await this.getProjectConfigurations() // Consulta de configuraciones del proyecto
    } catch (error) {
      this.getNotificationErrorMessage(error)
    }
  },

  updated () {
    this.options.nombre.options = this.optionsFilterPartyNamePartiesServices
    this.options.idfiscal.options = this.optionsFilterPartyTaxIdNumberPartiesServices
  }
}

</script>

<style lang="scss" scoped>
::v-deep .ods-input__prefix {
  height: 72px !important;
}
::v-deep .ods-input__suffix {
  height: 72px !important;
}
.b2b-filters{
  ::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
  }
::v-deep .ods-icon-close, body .ods-icon-close {

    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -4px;
    color: var(--color-bg-interactive);
}
::v-deep .ods-tag {

    display: inline-block;
    height: 24px;
    line-height: 14px;
    background-color: white;
    padding-top: 5px;
    font-size: 9px;
    color: var(--color-bg-interactive);
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "微软雅黑", Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 1px solid;
}
::v-deep .ods-select .ods-tag {
    display: inline-flex;
    margin: 2px 0 -52px 6px;
    .ods-tag__content {
      .ods-select__tags-text {
        text-transform: none;
      }
      max-width: 100%;
    min-width: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: calc(100% - 8px);
    display: inline-block;
    vertical-align: bottom;
    }
  }
  .b2b-filters__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
  }
    // background-color: var(--color-bg-primary);
    // border-top: .1rem solid $grey-2;
    // box-shadow: 0 .2rem .8rem 0 rgba(0, 0, 0, 0.08);
    .dateHeader {
      font-size: 12px;
      padding: 0 28px 0 20px;
      color: var(--color-txt-secondary);
    }
    .rightbut{
      padding: 8px 10px;
      display: inline;
      margin-right: 1.2rem;
    }
    .ods-button{
      padding: 8px 9px;
      display: inline;
    }

    ::v-deep &__area {
        display: flex;

        .ods-form-item {
            margin-bottom: 0;
            &__content {
                line-height: inherit;
            }
            &__error {
                top: rem(55);
            }
            input {
                max-width: rem(200);
            }
            select {
                max-width: rem(200);
            }
        }

        .first-input {
            margin-right: rem(32);
        }

        // Para los input que no sean datepicker,
        // colocar un margen igual a como si tuviese el botón del datepicker
        .others-input {
            margin-right: rem(16);
        }

        .ods-range-separator {
            padding: 0 rem(8);
        }
    }

    &__group {
        padding: 0 1.5rem 1.25rem 1.5rem;
        height: auto;

        .clean-filters {
      color: var(--color-status-info-400);
            .ods-icon-delete {
                margin-left: 0px;
            }
    }
    }

    &__button {
        margin: 0 0 0 1.25rem;
        display: inline-block;
        width: auto;
    }
    .ods-button + .ods-button {
        margin-right: 12px;
        margin-left: 0px!important;
      }
}
::v-deep .b2b-search-bar__header {
  display: -webkit-box;
}
</style>
